export const state = {
    attendances: [],
    attendance: [],
    systemAttend: []
}
export default state


// WEBPACK FOOTER //
// ./src/vuex/modules/attendances/state.js